import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useCustomModel } from "components/context/CustomProvider";
import { useNiceModalLocker } from "components/context/NiceModalProvider";
import CustomDialog from "../CustomDialog";
import CustomModelProvider from "../CustomModelProvider";
import CustomForm from "../forms/CustomForm";
import useCustomDataSource from "../useCustomDataSource";

const ModelUpdateModal = (modelName) => {
  if (!modelName) {
    throw new Error("ModelUpdateModal requires a modelName");
  }

  return NiceModal.create(({ id }) => {
    const modal = useModal();
    const model = useCustomModel(modelName);
    const dataSource = useCustomDataSource(modelName);
    const { locked, setLocked, closeFormIfNotLocked, forceClose } =
      useNiceModalLocker(modal);

    return (
      <CustomModelProvider modelName={modelName} id={id}>
        {(data, reftech) => (
          <CustomDialog
            variant="dialog"
            open={modal.visible}
            onClose={closeFormIfNotLocked}
          >
            <CustomForm
              title={`Update ${model.modelName}${locked ? " (Locked)" : ""}`}
              defaultValues={data}
              fields={model.fields}
              submitter={dataSource.updateOne}
              deleter={dataSource.deleteOne}
              onDone={modal.hide}
              onDeleted={modal.hide}
              onCancel={forceClose}
              onIsDirty={setLocked}
              modelName={modelName}
            />
          </CustomDialog>
        )}
      </CustomModelProvider>
    );
  });
};

export default ModelUpdateModal;
